<template>
  <div class="row">
    <div class="d-flex col-12 mt-4">
      <div class="label d-flex justify-content-end col-lg-3">
        <label class="word-custom">{{options.title}}</label>
      </div>
      <div class="form-group mb-0">
        <label
          v-for="option in options.options" :key="option.value"
          :for="`${option.value}-${randomKey}`"
          class="control-label checkbox-inline ml-2 mr-4 mb-0"
        >
          <input
            :id="`${option.value}-${randomKey}`"
            type="radio"
            :value="option.value"
            v-model="data[options.name]"
          />
          <span class="word-custom-radio">{{ option.title }}</span>
        </label>
        <slot />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Topic",
  props: {
    options: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
      randomKey: Math.floor(Math.random() * 1000),
    }
  },
  created() {
    const valueSet = new Set();
    for (const option of this.options.options) {
      if (valueSet.has(option.value)) {
        throw new Error(`Duplicate option value found: ${option.value}`);
      }
      valueSet.add(option.value);
    }
    this.randomKey = Math.floor(Math.random() * 1000)
  },
};
</script>

<style scoped>
.word-custom-radio {
	color: #666666;
	font-weight: 400;
}
.word-custom {
	color: #666666;
	font-size: 15.4px;
}
</style>